var path = '/app/webpack/wealthbar/components/meter/meter.html.slim';
var html = "<div class=\"meter\"><span ng-style=\"style\" style=\"width: 0%\"></span></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;